import { css } from 'linaria'
import theme from 'style/theme'

export default css`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.text};
`
